<template>
  <a-layout class="index animated fadeIn">
    <div class="s_bf">
      <a-form
        ref="ruleForm"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item ref="level" label="资质名称" name="level">
          <div class="s_flex_ali">
            <p class="s_c333 mr15">中国商标权证书</p>
            <div class="s_flex_ali">
              <WarningOutlined v-if="status !== 1" class="s_cd41" />
              <CheckOutlined v-else class="s_c376" />
              <p>{{ status_text }}</p>
            </div>
          </div>
        </a-form-item>
        <a-form-item
          ref="brand_name"
          label="品牌名称"
          name="brand_name"
          :rules="[
            {
              required: true,
              message: '请输入品牌名称'
            }
          ]"
        >
          <a-input
            v-model:value="form.brand_name"
            placeholder="请输入企业名称"
          />
        </a-form-item>
        <a-form-item
          ref="trademark_no"
          label="商标注册号/申请号"
          name="trademark_no"
          :rules="[
            {
              required: true,
              message: '请输入商标注册号/申请号'
            }
          ]"
        >
          <a-input
            v-model:value="form.trademark_no"
            placeholder="请输入商标注册号/申请号"
          />
        </a-form-item>
        <a-form-item
          ref="trademark_images"
          label="中国商标权证书"
          name="trademark_images"
        >
          <div class="flex">
            <div class="flex overflow-hidden">
              <a-image-preview-group
                class="overflow-hidden"
                v-if="form.trademark_images"
              >
                <a-image
                  class="overflow-hidden"
                  :width="100"
                  :height="100"
                  :src="info.picdomain + form.trademark_images"
                />
              </a-image-preview-group>
            </div>
            <div class="w-100 h-100 relative ml-10" v-if="formType == 'edit'">
              <div
                class="w-0100 h-0100 flex items-center justify-center border-1 border-dashed "
                style="border-color: #ddd;"
              >
                <PlusOutlined />
              </div>
              <uploadImage
                @success="uploadOnSuccess('trademark_images', $event)"
                class="opacity-0 absolute left-0 top-0 w-0100 h-0100 z-1"
              ></uploadImage>
            </div>
          </div>
        </a-form-item>
        <a-form-item ref="extend_images" label="补充材料" name="extend_images">
          <div class="flex">
            <div class="flex overflow-hidden">
              <a-image-preview-group
                class="overflow-hidden"
                v-if="form.extend_images"
              >
                <a-image
                  class="overflow-hidden"
                  :width="100"
                  :height="100"
                  :src="info.picdomain + form.extend_images"
                />
              </a-image-preview-group>
            </div>
            <div class="w-100 h-100 relative ml-10" v-if="formType == 'edit'">
              <div
                class="w-0100 h-0100 flex items-center justify-center border-1 border-dashed "
                style="border-color: #ddd;"
              >
                <PlusOutlined />
              </div>
              <uploadImage
                @success="uploadOnSuccess('extend_images', $event)"
                class="opacity-0 absolute left-0 top-0 w-0100 h-0100 z-1"
              ></uploadImage>
            </div>
          </div>
        </a-form-item>
        <a-row v-if="formType == 'edit'">
          <a-col :offset="labelCol.span">
            <a-button type="primary" @click="onSubmit">保存</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-layout>
</template>
<script>
import {
  WarningOutlined,
  CheckOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject, watchEffect } from "vue";
import store from "@/store";
import { message } from "ant-design-vue";
import uploadImage from "@/components/image/uploadImage.vue";
// 初始化默认筛选项数值
let defForm = {
  brand_name: "",
  trademark_no: "",
  trademark_images: "",
  extend_images: ""
};
export default {
  name: "licence",
  components: { WarningOutlined, CheckOutlined, PlusOutlined, uploadImage },
  props: {
    formData: {
      type: Object
    },
    // 类型，add新增、edit修改、detail查看
    formType: {
      type: String,
      default: "detail"
    }
  },
  setup(props, { emit }) {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      info: store.state.user.info,
      status: 0,
      status_text: "未认证",
      labelCol: { span: 5 },
      wrapperCol: { span: 19 }
    });
    const ruleForm = ref();
    const _lodash = inject("_lodash");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(() => {
          emit("onsubmit", form.value);
        })
        .catch((error) => {
          console.log("error", error);
        });
    };
    onMounted(() => {});

    watchEffect(() => {
      var formData = JSON.parse(JSON.stringify(props.formData)) || {};
      console.log(formData);
      if (!_lodash.isEmpty(formData.content)) {
        formData.content.trademark_images = _lodash.isArray(
          formData.content.trademark_images
        )
          ? _lodash.get(formData.content.trademark_images, "[0]")
          : formData.content.trademark_images;
        formData.content.extend_images = _lodash.isArray(
          formData.content.extend_images
        )
          ? _lodash.get(formData.content.extend_images, "[0]")
          : formData.content.extend_images;
        form.value = formData.content;
        state.status = formData.status;
        state.status_text = formData.status_text;
      } else {
        form.value = defForm;
        state.status = formData.status;
        state.status_text = formData.status_text;
      }
    });

    // 图片上传
    const uploadOnSuccess = (type, data) => {
      form.value[type] = data.path;
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      uploadOnSuccess
    };
  }
};
</script>
<style></style>
